<ng-template #portal>
  <div class="ui-slideout-modal-stack">
    <ng-content></ng-content>
  </div>
</ng-template>
